import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { auth, firestore } from "../../db/config";

export default function InvestmentPagePlan() {
  const investmentReducer = useSelector((state) => state.investmentReducer);
  const getInvestmentDetails = investmentReducer ? investmentReducer.plans : "";

  const dispatch = useDispatch();
  const [user, setuser] = useState(false);
  useEffect(() => {
    const getRef = firestore.collection("investmentPlan").get();
    getRef.then((plans) => {
      const getPlans = plans.docs.map((data) => data.data());

      dispatch({ type: "investment_details", data: getPlans });
    });

    auth.onAuthStateChanged((user) => {
      if (user.uid) {
        setuser(true);
      } else {
        setuser(false);
      }
    });
  },[]);
const handleAlert=()=>{
  alert("Please login to start investing")
}
  return (
    <div>
      <div class="sv_pricing_paln fixed_portion  float_left">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_wrapper_dark dark_heading">
                <h4> our plans </h4>
                <h3> Our Investment Plans </h3>
              </div>
            </div>
            <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
              {user ? (
                <a href="/deposit">
                  <div class="investment_box_wrapper sv_pricing_border float_left">
                    <div class="investment_icon_circle">
                      <i class="flaticon-bar-chart"></i>
                    </div>
                    <div class="investment_border_wrapper"></div>
                    <div class="investment_content_wrapper">
                      <h1>
                        <a href="/deposit">
                          {getInvestmentDetails
                            ? getInvestmentDetails[0].planName
                            : ""}
                        </a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[0].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              ) : (
                <div class="investment_box_wrapper sv_pricing_border float_left"  onClick={handleAlert}>
                  <div class="investment_icon_circle">
                    <i class="flaticon-bar-chart"></i>
                  </div>
                  <div class="investment_border_wrapper"></div>
                  <div class="investment_content_wrapper">
                    <h1>
                      <a href="#">
                        {getInvestmentDetails
                          ? getInvestmentDetails[0].planName
                          : ""}
                      </a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[0].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              )}
            </div>
            <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
              {user ? (
                <a href="/deposit">
                  <div class="investment_box_wrapper sv_pricing_border float_left">
                    <div class="investment_icon_circle red_info_circle">
                      <i class="flaticon-money"></i>
                    </div>
                    <div class="investment_border_wrapper red_border_wrapper"></div>
                    <div class="investment_content_wrapper red_content_wrapper">
                      <h1>
                        <a href="/deposit">
                          {getInvestmentDetails
                            ? getInvestmentDetails[2].planName
                            : ""}
                        </a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[2].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn red_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              ) : (
                <div class="investment_box_wrapper sv_pricing_border float_left"  onClick={handleAlert}>
                  <div class="investment_icon_circle red_info_circle">
                    <i class="flaticon-money"></i>
                  </div>
                  <div class="investment_border_wrapper red_border_wrapper"></div>
                  <div class="investment_content_wrapper red_content_wrapper">
                    <h1>
                      <a href="#">
                        {getInvestmentDetails
                          ? getInvestmentDetails[2].planName
                          : ""}
                      </a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[2].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn red_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              )}
            </div>
            <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
              {user ? (
                <a href="/deposit">
                  {" "}
                  <div class="investment_box_wrapper sv_pricing_border float_left">
                    <div class="investment_icon_circle blue_icon_circle">
                      <i class="flaticon-gold"></i>
                    </div>
                    <div class="investment_border_wrapper blue_border_wrapper"></div>
                    <div class="investment_content_wrapper blue_content_wrapper">
                      <h1>
                        <a href="/deposit">
                          {getInvestmentDetails
                            ? getInvestmentDetails[3].planName
                            : ""}
                        </a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[3].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn blue_btn_plans">
                 <ul>
                   <li>
                     <a href="#">read more</a>
                   </li>
                 </ul>
               </div> */}
                  </div>
                </a>
              ) : (
                <div class="investment_box_wrapper sv_pricing_border float_left"  onClick={handleAlert}>
                  <div class="investment_icon_circle blue_icon_circle">
                    <i class="flaticon-gold"></i>
                  </div>
                  <div class="investment_border_wrapper blue_border_wrapper"></div>
                  <div class="investment_content_wrapper blue_content_wrapper">
                    <h1>
                      <a href="#">
                        {getInvestmentDetails
                          ? getInvestmentDetails[3].planName
                          : ""}
                      </a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[3].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn blue_btn_plans">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              )}
            </div>
            <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
              {user ? (
                <a href="/deposit">
                  <div class="investment_box_wrapper sv_pricing_border float_left">
                    <div class="investment_icon_circle green_info_circle">
                      <i class="flaticon-medal"></i>
                    </div>
                    <div class="investment_border_wrapper green_border_wrapper"></div>
                    <div class="investment_content_wrapper green_content_wrapper">
                      <h1>
                        <a href="/deposit">
                          {getInvestmentDetails
                            ? getInvestmentDetails[1].planName
                            : ""}
                        </a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[1].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn green_plan_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              ) : (
                <div class="investment_box_wrapper sv_pricing_border float_left"  onClick={handleAlert}>
                  <div class="investment_icon_circle green_info_circle">
                    <i class="flaticon-medal"></i>
                  </div>
                  <div class="investment_border_wrapper green_border_wrapper"></div>
                  <div class="investment_content_wrapper green_content_wrapper">
                    <h1>
                      <a href="#">
                        {getInvestmentDetails
                          ? getInvestmentDetails[1].planName
                          : ""}
                      </a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[1].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn green_plan_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              )}
            </div>
            <div class="col-xl-3 col-md-6 col-lg-6 col-sm-6 col-12">
              {user ? (
                <a href="/deposit">
                  <div class="investment_box_wrapper sv_pricing_border float_left">
                    <div class="investment_icon_circle green_info_circle">
                      <i class="flaticon-medal"></i>
                    </div>
                    <div class="investment_border_wrapper green_border_wrapper"></div>
                    <div class="investment_content_wrapper green_content_wrapper">
                      <h1>
                        <a href="/deposit">
                          {getInvestmentDetails
                            ? getInvestmentDetails[4].planName
                            : ""}
                        </a>
                      </h1>
                      <p>
                        {getInvestmentDetails
                          ? getInvestmentDetails[4].intrestTag
                          : ""}
                      </p>
                    </div>
                    {/* <div class="about_btn plans_btn green_plan_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                  </div>
                </a>
              ) : (
                <div class="investment_box_wrapper sv_pricing_border float_left" onClick={handleAlert}>
                  <div class="investment_icon_circle green_info_circle">
                    <i class="flaticon-medal"></i>
                  </div>
                  <div class="investment_border_wrapper green_border_wrapper"></div>
                  <div class="investment_content_wrapper green_content_wrapper">
                    <h1>
                      <a href="#">
                        {getInvestmentDetails
                          ? getInvestmentDetails[4].planName
                          : ""}
                      </a>
                    </h1>
                    <p>
                      {getInvestmentDetails
                        ? getInvestmentDetails[4].intrestTag
                        : ""}
                    </p>
                  </div>
                  {/* <div class="about_btn plans_btn green_plan_btn">
                  <ul>
                    <li>
                      <a href="#">read more</a>
                    </li>
                  </ul>
                </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
